(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ar-announcement-marquee"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-marquee-toggle]').forEach(button=>button.addEventListener('click',()=>{const root=button.closest('[data-ar-marquee]');const paused=root.dataset.paused!=='true';root.dataset.paused=String(paused);button.setAttribute('aria-pressed',String(paused));button.setAttribute('aria-label',paused?button.dataset.playLabel:button.dataset.pauseLabel);button.textContent=paused?'▶':'Ⅱ'}));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ar-fleece-reviews"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-review-step]').forEach(button=>button.addEventListener('click',()=>{const rail=button.closest('section').querySelector('.ar-review-rail');rail.scrollBy({left:Number(button.dataset.reviewStep)*(rail.querySelector('article').getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap||0)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ar-fur-flash-sale"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ar-fur-flash')) {
    customElements.define('ar-fur-flash', class extends HTMLElement {
      connectedCallback() {
        this.endTime = Date.parse(this.dataset.endsAt);
        if (!Number.isFinite(this.endTime)) { this.hidden = true; return; }
        this.tick();
        if (!this.hidden) this.timer = setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() { clearInterval(this.timer); }
      tick() {
        const remaining = Math.max(0, Math.floor((this.endTime - Date.now()) / 1000));
        if (!remaining) { this.hidden = true; clearInterval(this.timer); return; }
        const parts = {days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};
        for (const [part, value] of Object.entries(parts)) {
          const node = this.querySelector(`[data-flash-${part}]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ar-photo-review-rail"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('[data-review-step]').forEach(button=>button.addEventListener('click',()=>{const rail=button.closest('section').querySelector('.ar-review-rail');rail.scrollBy({left:Number(button.dataset.reviewStep)*(rail.querySelector('article').getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap||0)),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'})}));
  } catch(e) { console.error(e); }
})();

})();
